export interface ICartAdminPayerLabelProps {
  display?: boolean;
}

export const CartAdminPayerLabel: React.FC<ICartAdminPayerLabelProps> = (
  props: ICartAdminPayerLabelProps
) => {
  if (!props.display) {
    return null;
  }

  return (
    <div className="cart-admin-payer-label my-3">
      <div>Payment will be handled by MerchStore admin.</div>
      <div>
        By placing your order, you agree to Merchology’s{' '}
        <a href="https://www.merchology.com/policies/terms-of-service">
          Terms of Service
        </a>{' '}
        and{' '}
        <a href="https://www.merchology.com/policies/privacy-policy">
          Privacy Policy
        </a>
      </div>
    </div>
  );
};
